export default __webpack_public_path__ + "static/media/closeicon.40859678.svg";